import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-brand-bg" data-testid="privacy-page">
      <header className="border-b border-brand-line bg-white/60 backdrop-blur-sm sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-brand-inkSoft hover:text-brand-ink transition" data-testid="privacy-back">
            <ArrowLeft className="w-4 h-4" />
            <span className="text-sm">Indietro</span>
          </Link>
          <span className="font-heading text-lg text-brand-ink">24Vox</span>
          <div className="w-16"></div>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-16 prose prose-stone">
        <p className="text-xs font-medium tracking-[0.25em] text-brand-terra uppercase mb-4">Informativa</p>
        <h1 className="font-heading text-4xl md:text-5xl text-brand-ink mb-2">Privacy Policy</h1>
        <p className="text-brand-inkSoft mb-12">Ultimo aggiornamento: febbraio 2026</p>

        <div className="space-y-8 text-brand-ink leading-relaxed">
          <section>
            <h2 className="font-heading text-2xl mb-3">1. Chi siamo</h2>
            <p>Il titolare del trattamento dei dati è 24Vox, con sede in Italia. Per qualsiasi domanda relativa ai tuoi dati personali, scrivi a <a href="mailto:robs@24vox.it" className="text-brand-olive underline">robs@24vox.it</a>.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">2. Quali dati raccogliamo</h2>
            <p>Quando utilizzi la demo di 24Vox raccogliamo:</p>
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>L'indirizzo del tuo sito web aziendale</li>
              <li>La tua email aziendale</li>
              <li>Il contenuto delle conversazioni che intrattieni con la nostra AI</li>
              <li>Il tuo indirizzo IP e dati tecnici di navigazione (per limitare abusi)</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">3. Perché li trattiamo</h2>
            <p>Trattiamo i tuoi dati per: (a) farti provare il servizio demo personalizzato sulla tua azienda; (b) inviarti il riassunto della conversazione e proporti l'attivazione del servizio commerciale; (c) prevenire abusi e tutelare l'integrità del servizio.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">4. A chi li comunichiamo</h2>
            <p>I dati vengono elaborati da fornitori tecnici per la generazione delle risposte AI (Anthropic, OpenAI), per la sintesi vocale (ElevenLabs) e per l'invio di comunicazioni. Non vendiamo i tuoi dati a terzi.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">5. Per quanto tempo</h2>
            <p>Conserviamo i dati delle demo per 90 giorni, dopodiché vengono cancellati salvo che tu non sottoscriva un piano commerciale.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">6. I tuoi diritti</h2>
            <p>Hai diritto di accedere, rettificare, cancellare i tuoi dati e di opporti al loro trattamento. Per esercitare questi diritti, scrivi a <a href="mailto:robs@24vox.it" className="text-brand-olive underline">robs@24vox.it</a> e ti rispondiamo entro 30 giorni.</p>
          </section>

          <section>
            <h2 className="font-heading text-2xl mb-3">7. Cookie</h2>
            <p>Il sito utilizza cookie tecnici necessari al funzionamento e cookie analitici anonimi per capire come viene usato. Non utilizziamo cookie di profilazione di terze parti.</p>
          </section>
        </div>
      </main>
    </div>
  );
}
